// extracted by mini-css-extract-plugin
export default {"cls1":"PostPrompt-cls1_Pd7","cls2":"PostPrompt-cls2_qnc PostPrompt-cls1_Pd7"};